export enum OS {
  IOS = 'iOS',
  ANDROID = 'Android',
  OTHER = 'Other',
}

export function detectOS(): OS {
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    return OS.ANDROID;
  } else if (/iPad|iPhone|iPod/.test(userAgent)) {
    return OS.IOS;
  } else {
    return OS.OTHER;
  }
}
